<div class="projects-container">
  @for(project of projects(); track $index){
  <app-project-card [project]="project"></app-project-card>
  }
</div>
